import React from 'react'
import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import {
  DcBreadcrumbs,
  DcFlexBox,
  PixelPageContainer,
  PixelTopBar,
  DcDiv,
  Section,
  SectionContent,
} from 'pixel-base'

import Stores from './components/subcomponents/Stores'
const AddStores = (props) => {
  const breadcrumbs = [
    {
      name: 'Settings',
      active: false,
    },
    {
      name: 'Linked Stores',
      active: false,
      link: '/admin/stores/',
    },
    {
      name: 'Add Stores',
      active: true,
    },
  ]
  return (
    <>
      <DcFlexBox
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        padding=".5rem 20px"
        height="60px"
        style={{
          borderBottom: '1px solid #e5e5e5',
        }}
      >
        <DcDiv>
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} className="px-0" />
        </DcDiv>
        <DcDiv>
          <ProfileSection />
        </DcDiv>
      </DcFlexBox>

      <PixelPageContainer>
        <Section>
          <SectionContent>{<Stores {...props} />}</SectionContent>
        </Section>
      </PixelPageContainer>
    </>
  )
}

export default AddStores
